import apiClient from '../../../Services/ApiClient';

export const markFileAsPrinted = async (
	patientId: string,
	fileId: string,
	value: boolean,
) => {
	return await apiClient.put(`/files/${patientId}/${fileId}/markAsPrinted`, {
		value: value,
	});
};
